import { useQuery } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { GetClientDocumentsResponse } from '@/types/clientsApiTypes';
import { CLIENT_CREATE_DOCUMENTS_QUERY_KEY } from '../../const/const';

export const useGetClientDocuments = (clientId?: string | number | null) => {
  const { doFetch: getClientDocuments } = useFetch<void, GetClientDocumentsResponse>();

  return useQuery({
    queryKey: [CLIENT_CREATE_DOCUMENTS_QUERY_KEY, clientId],
    queryFn: () =>
      getClientDocuments(`/api/documents/client/${clientId}`, {
        method: 'GET',
      }),
    enabled: !!clientId,
  });
};